"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _icons = require("../../legacy/icons");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _excluded = ["arrowColor"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Wrapper = (0, _styledComponents["default"])(function (_ref) {
  var arrowColor = _ref.arrowColor,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, rest);
}).withConfig({
  displayName: "arrow__Wrapper",
  componentId: "sc-2q59tu-0"
})(["background-color:", ";", " ", ";"], function (props) {
  return (0, _styles.themeTransparentize)(0.9, props.arrowColor, props);
}, function (props) {
  return props.disabled ? (0, _styledComponents.css)(["opacity:0.35;"]) : (0, _styledComponents.css)(["cursor:pointer;&:hover{background-color:", ";}"], (0, _styles.themeTransparentize)(0.8, props.arrowColor, props));
}, (0, _styles.transitionEase)("1.7s", ["color", "background-color", "opacity"]));
var propTypesArrow = {
  className: _propTypes.string,
  direction: _propTypes.string
};

var ArrowIcon = function ArrowIcon(_ref2) {
  var className = _ref2.className,
      direction = _ref2.direction;
  var Icon = direction === "left" ? _icons.ArrowLeftIcon : _icons.ArrowRightIcon;
  return /*#__PURE__*/_react["default"].createElement(Icon, {
    className: className
  });
};

ArrowIcon.propTypes = propTypesArrow;
var Icon = (0, _styledComponents["default"])(ArrowIcon).withConfig({
  displayName: "arrow__Icon",
  componentId: "sc-2q59tu-1"
})(["position:absolute;height:20px;width:20px;left:50%;top:50%;transform:translate(-50%,-50%);"]);
var propTypes = {
  className: _propTypes.string,
  color: _propTypes.string,
  customArrow: _propTypes.func,
  direction: _propTypes.string,
  disabled: _propTypes.bool,
  light: _propTypes.bool,
  onClick: _propTypes.func
};
var defaultProps = {
  disabled: false,
  light: false
};

var Arrow = function Arrow(_ref3) {
  var color = _ref3.color,
      light = _ref3.light,
      className = _ref3.className,
      customArrow = _ref3.customArrow,
      disabled = _ref3.disabled,
      direction = _ref3.direction,
      onClick = _ref3.onClick;
  var defaultColor = light ? "white" : "black";
  return customArrow ? customArrow({
    disabled: disabled,
    onClick: onClick
  }) : /*#__PURE__*/_react["default"].createElement(Wrapper, {
    arrowColor: color || defaultColor,
    borderRadius: "50%",
    className: className,
    color: color || defaultColor,
    disabled: disabled,
    fill: color || defaultColor,
    height: 46,
    light: light ? "true" : "false",
    onClick: disabled ? null : onClick,
    position: "relative",
    width: 46
  }, /*#__PURE__*/_react["default"].createElement(Icon, {
    direction: direction
  }));
};

Arrow.defaultProps = defaultProps;
Arrow.propTypes = propTypes;
var _default = Arrow;
exports["default"] = _default;